<template>
  <div class="row blaPrologueContainer">
    <div class="col-10 offset-1 col-md-10 offset-md-1">
      <div class="row mt-5 mb-2">
        <div class="col-2 text-right">
          <img
            :src="require('@/assets/img/exclamation_mark_icon.png')"
            alt="exclamation_mark_icon"
            class="blaExlaminationIcon align-self-center"
          />
        </div>
        <div class="col-10 blaPrologueTitle">
          Értékeld magad! <br />
          A csillagok kiválasztásával megadhatod, mennyire volt könnyű vagy
          nehéz számodra ez a lecke.
          <ul class="mt-2 list-unstyled">
            <li>1 csillag: nagyon nehéz</li>
            <li>2 csillag: meg gyakorolnom kell</li>
            <li>3 csillag: tökéletesen megy</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-10 offset-1 col-md-10 offset-md-1">
      <div class="row mt-5 mb-2">
        <div class="col-10 offset-1 text-center">
          <img
            @mouseover="changeStar('full', 1)"
            @mouseleave="changeStar('empty', 1)"
            @click="setStar(1)"
            :src="star[1]['file']"
            alt="star"
            class="img-fluid d-inline-block clickable"
          />
          <img
            @mouseover="changeStar('full', 2)"
            @mouseleave="changeStar('empty', 2)"
            @click="setStar(2)"
            :src="star[2]['file']"
            alt="star"
            class="img-fluid d-inline-block clickable mx-3"
          />
          <img
            @mouseover="changeStar('full', 3)"
            @mouseleave="changeStar('empty', 3)"
            @click="setStar(3)"
            :src="star[3]['file']"
            alt="star"
            class="img-fluid d-inline-block clickable"
          />
        </div>
      </div>
    </div>
    <div
      v-show="nextButton"
      class="col-4 col-md-2 offset-4 offset-md-5 text-center"
    >
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div
          :class="{ disabled: !nextButton }"
          class="blaPrologueNextButton p-3 clickable"
          @click="goToNext"
        >
          Tovább
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {},
  data: () => ({
    lessonId: "",
    selfValue: 0,
    nextButton: false,
    star: {
      1: {
        file: require("@/assets/img/star_empty.png"),
        clicked: false,
      },
      2: {
        file: require("@/assets/img/star_empty.png"),
        clicked: false,
      },
      3: {
        file: require("@/assets/img/star_empty.png"),
        clicked: false,
      },
    },
  }),
  methods: {
    saveSelfValue() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/selfValue/saveOrUpdate", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
          selfValue: this.selfValue,
        })
        .then((response) => {
          if (response.status == 200) {
            this.nextButton = true;
          }
        })
        .catch((error) => {
          console.log("selfValue - error: ", error);
        });
    },
    goToNext() {
      if (this.$route.params.fromAudioBook) {
        this.$router.push({
          name: "summaryAudioBook",
          params: { lessonId: this.lessonId },
        });
      } else {
        this.$router.push({
          name: "summary",
          params: { lessonId: this.lessonId },
        });
      }
    },
    changeStar(state, id) {
      //   console.log('star changed', id, this.star[id]);
      if (state == "full") {
        if (id > 2) {
          this.star[1]["file"] = require("@/assets/img/star.png");
          this.star[2]["file"] = require("@/assets/img/star.png");
          this.star[3]["file"] = require("@/assets/img/star.png");
        }
        if (id == 2) {
          this.star[1]["file"] = require("@/assets/img/star.png");
          this.star[2]["file"] = require("@/assets/img/star.png");
        }
        if (id < 2) {
          this.star[1]["file"] = require("@/assets/img/star.png");
        }
      } else {
        if (id > 2) {
          this.star[1]["clicked"] === false
            ? (this.star[1]["file"] = require("@/assets/img/star_empty.png"))
            : null;
          this.star[2]["clicked"] === false
            ? (this.star[2]["file"] = require("@/assets/img/star_empty.png"))
            : null;
          this.star[3]["clicked"] === false
            ? (this.star[3]["file"] = require("@/assets/img/star_empty.png"))
            : null;
        }
        if (id == 2) {
          this.star[1]["clicked"] === false
            ? (this.star[1]["file"] = require("@/assets/img/star_empty.png"))
            : null;
          this.star[2]["clicked"] === false
            ? (this.star[2]["file"] = require("@/assets/img/star_empty.png"))
            : null;
        }
        if (id < 2) {
          this.star[1]["clicked"] === false
            ? (this.star[1]["file"] = require("@/assets/img/star_empty.png"))
            : null;
        }
      }
    },
    setStar(id) {
      if (id == 3) {
        this.star[1]["file"] = require("@/assets/img/star.png");
        this.star[1]["clicked"] = true;
        this.star[2]["file"] = require("@/assets/img/star.png");
        this.star[2]["clicked"] = true;
        this.star[3]["file"] = require("@/assets/img/star.png");
        this.star[3]["clicked"] = true;

        this.selfValue = 3;
      }
      if (id == 2) {
        this.star[1]["file"] = require("@/assets/img/star.png");
        this.star[1]["clicked"] = true;
        this.star[2]["file"] = require("@/assets/img/star.png");
        this.star[2]["clicked"] = true;
        this.star[3]["file"] = require("@/assets/img/star_empty.png");
        this.star[3]["clicked"] = false;

        this.selfValue = 2;
      }
      if (id == 1) {
        this.star[1]["file"] = require("@/assets/img/star.png");
        this.star[1]["clicked"] = true;
        this.star[2]["file"] = require("@/assets/img/star_empty.png");
        this.star[2]["clicked"] = false;
        this.star[3]["file"] = require("@/assets/img/star_empty.png");
        this.star[3]["clicked"] = false;

        this.selfValue = 1;
      }

      this.saveSelfValue();
    },
  },
  computed: {
    ...mapGetters(["user", "apiUrl"]),
  },
  mounted: function () {
    this.lessonId = this.$store.getters.currentLessonId;

    if (this.$route.params.fromAudioBook) {
      console.log("yeah - from audiobook");
    }
  },
};
</script>
